const productStories = document.querySelector('.product__stories');

if (productStories) {

    const productStoriesModal = document.querySelector('.product__stories-modal');

    function openStoriesModal(startIndex = 0) {
        productStoriesModal.setAttribute('open', '');
        // Aller à la slide correspondante
        if (productStoriesSwiper) {
            productStoriesSwiper.slideTo(startIndex, 0); // 0 = pas d'animation
        }
    }

    function closeStoriesModal() {
        productStoriesModal.removeAttribute('open');
        // Pause toutes les vidéos
        const allVideos = productStoriesModal.querySelectorAll('video');
        allVideos.forEach(video => {
            video.pause();
            video.currentTime = 0; // Remet la vidéo au début
        });
        
        // Reset toutes les barres de progression
        const allProgressBars = productStoriesModal.querySelectorAll('.progress');
        allProgressBars.forEach(progress => {
            progress.style.width = '0%';
        });
    }

    // Fonction pour mettre à jour la barre de progression
    function updateProgressBar(video, progressBar) {
        if (video.duration) {
            const percentage = (video.currentTime / video.duration) * 100;
            progressBar.style.width = percentage + '%';
        }
    }

    /* BLOCK - Gestion des clics sur les stories de prévisualisation */
    const stories = productStories.querySelectorAll('.stories .item');

    stories.forEach((story, index) => {
        const video = story.querySelector('video');
        
        // Clic sur la vidéo OU sur l'item entier
        const clickHandler = (e) => {
            e.preventDefault();
            e.stopPropagation();
            openStoriesModal(index);
        };
        
        if (video) {
            video.addEventListener('click', clickHandler);
        }
        story.addEventListener('click', clickHandler);
    });

    /* SWIPER - Initialisation après que le DOM soit prêt */
    let productStoriesSwiper;
    let globalSoundState = false; // true = muted, false = unmuted
    
    // Attendre que Swiper soit disponible
    if (typeof Swiper !== 'undefined') {
        initializeSwiper();
    } else {
        // Si Swiper n'est pas encore chargé, attendre un peu
        setTimeout(() => {
            if (typeof Swiper !== 'undefined') {
                initializeSwiper();
            }
        }, 100);
    }

    function initializeSwiper() {
        productStoriesSwiper = new Swiper(".product__stories-modal .mySwiper", {
            grabCursor: true,
            loop: false,
            touchRatio: 1.5,
            threshold: 10,
            longSwipesRatio: 0.1,
            cubeEffect: {
                shadow: true,
                slideShadows: true,
                shadowOffset: 20,
                shadowScale: 0.94,
            },
            spaceBetween: 10,
            pagination: {
                el: ".swiper-pagination",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            on: {
                slideChange: function() {
                    // Pause et remet à 0 toutes les vidéos
                    const allVideos = productStoriesModal.querySelectorAll('.item__video video');
                    const allProgressBars = productStoriesModal.querySelectorAll('.progress');
                    
                    allVideos.forEach((video, index) => {
                        video.pause();
                        video.currentTime = 0; // Remet à 0
                        
                        // Reset la barre de progression correspondante
                        if (allProgressBars[index]) {
                            allProgressBars[index].style.width = '0%';
                        }
                    });
                    
                    // Play la vidéo de la slide active avec l'état sonore global
                    const activeSlide = this.slides[this.activeIndex];
                    const activeVideo = activeSlide?.querySelector('.item__video video');
                    if (activeVideo) {
                        activeVideo.muted = globalSoundState;
                        activeVideo.play().catch(e => console.log('Autoplay prevented:', e));
                        
                        // Mise à jour du dataset de la slide active
                        activeSlide.dataset.soundStatus = globalSoundState ? "muted" : "unmuted";
                    }
                }
            }
        });
    }

    /* MODAL - Gestion des contrôles dans la modale */
    const videoSlides = productStoriesModal.querySelectorAll('.swiper-slide');

    videoSlides.forEach((slide, index) => {
        const slideControls = slide.querySelector('.item__controls');
        const closeButton = slideControls?.querySelector('.action__close');
        const soundButton = slideControls?.querySelector('.action__sounds');
        const video = slide.querySelector('.item__video video');
        const progressBar = slide.querySelector('.progress');

        // Configuration de la barre de progression pour cette vidéo
        if (video && progressBar) {
            // Événement timeupdate pour mettre à jour la barre de progression
            video.addEventListener('timeupdate', () => {
                updateProgressBar(video, progressBar);
            });

            // Événement loadedmetadata pour s'assurer que la durée est disponible
            video.addEventListener('loadedmetadata', () => {
                updateProgressBar(video, progressBar);
            });

            // Reset de la barre quand la vidéo se termine
            video.addEventListener('ended', () => {
                progressBar.style.width = '100%';
            });

            // Reset de la barre quand la vidéo est remise à 0
            video.addEventListener('seeked', () => {
                updateProgressBar(video, progressBar);
            });
        }

        // Bouton fermer
        if (closeButton) {
            closeButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                closeStoriesModal();
            });
        }

        // Bouton son (toggle mute/unmute)
        if (soundButton && video) {
            soundButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                // Toggle l'état sonore global
                globalSoundState = !globalSoundState;
                
                // Applique l'état à TOUTES les vidéos
                const allVideos = productStoriesModal.querySelectorAll('.item__video video');
                const allSlides = productStoriesModal.querySelectorAll('.swiper-slide');
                
                allVideos.forEach((vid, idx) => {
                    vid.muted = globalSoundState;
                    // Mise à jour du dataset de chaque slide
                    if (allSlides[idx]) {
                        allSlides[idx].dataset.soundStatus = globalSoundState ? "muted" : "unmuted";
                    }
                });
            });
        }

        // Gestion du click sur la vidéo pour pause/play
        if (video) {
            video.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                if (video.paused) {
                    video.play().catch(e => console.log('Play prevented:', e));
                } else {
                    video.pause();
                }
            });
        }
    });

    // Fermer la modale en cliquant en dehors
    productStoriesModal.addEventListener('click', (e) => {
        if (e.target === productStoriesModal) {
            closeStoriesModal();
        }
    });

    // Fermer avec la touche Échap
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && productStoriesModal.hasAttribute('open')) {
            closeStoriesModal();
        }
    });

    // Auto-play de la première vidéo quand la modale s'ouvre
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                if (productStoriesModal.hasAttribute('open')) {
                    // Modale ouverte - jouer la vidéo active avec l'état sonore global
                    setTimeout(() => {
                        const activeSlide = productStoriesModal.querySelector('.swiper-slide-active');
                        const activeVideo = activeSlide?.querySelector('.item__video video');
                        if (activeVideo) {
                            activeVideo.muted = globalSoundState;
                            activeVideo.currentTime = 0; // Remet à 0
                            activeVideo.play().catch(e => console.log('Autoplay prevented:', e));
                            
                            // Mise à jour du dataset
                            activeSlide.dataset.soundStatus = globalSoundState ? "muted" : "unmuted";
                        }
                    }, 100);
                }
            }
        });
    });

    observer.observe(productStoriesModal, {
        attributes: true,
        attributeFilter: ['open']
    });
}